import { PagingInfo } from './user'

export interface ClassesResponse {
  data: ClassItemType[]
  meta: PagingInfo
}
export interface ClassItemType {
  class_id: number
  class_name: string
  class_status: string
  module_name: string
  image_link: string
  tutors_name: string[]
  tutors: Tutor[]
  total_students: number
  module_id: number
  total_tests: number
}

export interface Tutor {
  image?: string | null
  full_name: string
}

export interface ClassDetailRes {
  id: number
  name: string
  module_name: string
  no_students: number
  marked_mock: number
  mock_attempts: number
  marked_pt: number
  pt_attempts: number
  chapters: Chapter[]
  tutor: string[]
}

export interface Chapter {
  name: string
  total_questions: number
}

export interface ClassStudentRes {
  data: ClassStudentItem[]
  meta: PagingInfo
}

export interface ClassStudentItem {
  user_id: number
  student_name: string
  me_attempts: number
  pt_attempts: number
  total_duration_minutes: number
  avg_marks: number
}

export interface Class {
  class_id: string
  class_name: string
  module_name: string
  image?: string
  total_students: number
  total_tests: number
  module_id: number
  tutors_name?: string[]
}

export interface ClassParams {
  page: number
  size: number
  limit?: number
  module_id: number | string | null
  query?: string
  is_active?: boolean
  years?: number[]
  year_asc?: boolean
  tutors?: string[]
}

export enum ClassStatus {
  active = 'active',
  deactivated = 'deactivated',
}

export interface ListYears {
  module_id: number
  years: number[]
}

export interface ListTutors {
  module_id: number
  tutors: TutorFilter[]
}

export interface TutorFilter {
  id: number
  username: string
  fullname: string
}

export interface ClassByModule {
  id: number
  name: string
  is_assign: boolean
}
